/**
 * Formats an ISO date string to DD.MM.YYYY.
 * @param isoDateString - The ISO date string to format.
 * @returns The formatted date string in DD.MM.YYYY format.
 */
export const formatDate = (isoDateString: Date): string => {
  const date = new Date(isoDateString);
  return date?.toLocaleDateString("sk-SK").replace(/\s/g, "");
};
